<template>
  <ul class="contacts-list">
    <li v-for="(item, i) in communications" :key="i">
      <IconAndTextComponent
        :icon="getIcon(item)"
        :value="item.value"
        :link="getLink(item)"
        :big="item.type.code === types.PHONE"
        :newTab="item.type.code === types.ADDRESS"
      />
    </li>
    <li>
      <IconAndTextComponent icon="clock" title="Режим работы" :value="schedule" />
    </li>
    <li v-if="showSocial">
      <SocialsComponent />
    </li>
  </ul>
</template>

<script>
import IconAndTextComponent from "components/IconAndTextComponent.vue";
import SocialsComponent from "components/SocialsComponent.vue";

export default {
  name: "ContactsComponent",
  props: {
    showSocial: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    communications() {
      if (
        this.$store.state.marketplace &&
        this.$store.state.marketplace.communications &&
        this.$store.state.marketplace.communications.length
      ) {
        return this.$store.state.marketplace?.communications
          .filter((item) => {
            return ![this.types.SOCIAL].includes(item.type.code);
          })
          .sort((a, b) => (a.type.code > b.type.code ? 1 : -1))
      }
      return [];
    },
    schedule() {
      return this.$store.state.marketplace?.schedule || undefined;
    },
    types() {
      return this.$store.state._types;
    },
  },
  methods: {
    getIcon(item) {
      switch (item.type.code) {
        case this.types.ADDRESS: {
          return "location";
        }
        case this.types.PHONE: {
          return "call";
        }
        case this.types.EMAIL: {
          return "sms";
        }
      }
    },
    getLink(item) {
      switch (item.type.code) {
        case this.types.PHONE: {
          return this.$options.filters.phone(item.value);
        }
        case this.types.EMAIL: {
          return `mailto:${item.value}`;
        }
        default: {
          return item.link;
        }
      }
    },
  },
  components: { SocialsComponent, IconAndTextComponent },
};
</script>

<style lang="stylus">
.contacts-list {
  display flex
  flex-direction column
  align-items flex-start
  justify-content flex-start
  gap 10px
}
</style>
